import React, { Suspense } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import dashboardRoutes from "./routes";
import Spinner from "react-bootstrap/Spinner";
import Layout from "layouts/Layouts";
import CommentaryLayout from "layouts/CommentaryLayout";
import { ToastContainer } from 'react-toastify';
import PrivateRoute from "./views/PrivateRoute";
import { history } from "./utils/basicHelpers";

const App = () => {

  const getRoutes = (routes) => {
    return routes.map((item, key) => {
      if (item?.path === "/") {
        return (
          <Route
            path={item.path}
            element={<item.component />}
            key={key}
            target={item.target ? item.target : null}
          />
        );
      }
      if (item?.layout === 1) {
        return (
          <Route element={<PrivateRoute />}>
          <Route element={<Layout />} key={key}>
            <Route path={item.path} element={<item.component />} />
          </Route>
          </Route>
        );
      } else if (item?.layout === 2) {
        return (
          <Route element={<PrivateRoute />}>
          <Route
            path={item.path}
            element={<item.component />}
            key={key}
            target={item.target ? item.target : null}
          />
          </Route>
        );
      } else if (item?.layout === 3) {
        return (
          <Route element={<PrivateRoute />}>
            <Route element={<CommentaryLayout />} key={key}>
              <Route path={item.path} element={<item.component />} />
            </Route>
          </Route>
        );
      } else {
        <Route element={<PrivateRoute />}>
        <Route
          path={item.path}
          element={<item.component />}
          key={key}
          target={item.target ? item.target : null}
        />;
        </Route>
      }
    });
  };

    history.navigate = useNavigate();
    history.location = useLocation();

  return (
    <Suspense
      fallback={
        <div className="loader-style">
          <Spinner animation="grow" />
        </div>
      }
    >
      <Routes>{getRoutes(dashboardRoutes)}</Routes>
      <ToastContainer />
    </Suspense>
  );
};

export default App;
